import { useTranslations } from "next-intl";
import EmptyMenu from "@/assets/icons/empty-menu.svg";
import { DietMenuWrapper } from "@/features/diets/components/diet-menu-modal/diet-menu-wrapper";
import type { DietCatalogDetail } from "@/features/diets/types";
import type { DietMenuPreviewMeals } from "@/features/diets/types/diet-menu-preview.type";

type DietMenuMealsListProps = {
  meals: DietMenuPreviewMeals[];
  data: DietCatalogDetail;
  activeAllergensAlert: boolean;
  setActiveMealIngredients: (mealId: string, dishId: string) => void;
  type?: "multidiet" | "default";
};

export const DietMenuMealsList = ({
  meals,
  data,
  activeAllergensAlert,
  setActiveMealIngredients,
  type,
}: DietMenuMealsListProps) => {
  const t = useTranslations();

  if (meals.length === 0) {
    return (
      <div className="grid place-items-center gap-4 rounded-lg bg-background px-6 py-8 text-lg shadow-xs">
        <EmptyMenu />
        {t("diets.errors.mealsNotFound")}
      </div>
    );
  }

  return (
    <>
      {meals.map((meal) => (
        <DietMenuWrapper
          activeAllergensAlert={activeAllergensAlert}
          data={data}
          key={meal.mealId}
          meal={meal}
          setActiveMealIngredients={setActiveMealIngredients}
          type={type}
        />
      ))}
    </>
  );
};
